/**
 * /frontend/src/features/analytics/components/queue/ThroughputByHourChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import ComparisonBarChart from '../charts/ComparisonBarChart';
import { CHART_COLORS } from '../../constants/chartColors';
import { toThroughputByHourSeries } from '../../utils/chartDataTransformers';

/**
 * Throughput by hour of day bar chart.
 * @param {{performance:any}} props
 * @returns {JSX.Element}
 */
const ThroughputByHourChart = ({ performance }) => {
  const data = useMemo(() => toThroughputByHourSeries(performance), [performance]);
  return (
    <ChartContainer title="Throughput by Hour" subtitle="Customers served per hour (0-23)">
      <ComparisonBarChart data={data} xKey="hourLabel" yKey="count" color={CHART_COLORS.accentCyan} />
    </ChartContainer>
  );
};

export default ThroughputByHourChart;

